import { FeatherOrderStatus } from '@src/pages/Exchange/components/FeatherOrderFlow/FeatherOrderStatus'
import { FeatherBackendStatus } from '@src/types/feather'

/**
 * Maps backend Feather status values to frontend FeatherOrderStatus enum values
 * This is necessary because the backend sends status strings that don't directly map to our frontend enum
 *
 * @param backendStatus - The status value from the backend API response
 * @returns The corresponding frontend FeatherOrderStatus value
 */
export function mapBackendToFrontendStatus(backendStatus: FeatherBackendStatus): FeatherOrderStatus {
    const statusMap: Record<FeatherBackendStatus, FeatherOrderStatus> = {
        // Waiting states
        [FeatherBackendStatus.UNKNOWN]: FeatherOrderStatus.UNKNOWN,
        [FeatherBackendStatus.PING]: FeatherOrderStatus.UNKNOWN,
        [FeatherBackendStatus.ORDER_RECEIVED]: FeatherOrderStatus.WAITING_FOR_DEPOSIT,
        [FeatherBackendStatus.PROCESSING]: FeatherOrderStatus.WAITING_FOR_DEPOSIT,
        [FeatherBackendStatus.AWAITING_DEPOSIT]: FeatherOrderStatus.WAITING_FOR_DEPOSIT,

        // Progress states
        [FeatherBackendStatus.DEPOSIT_CONFIRMED]: FeatherOrderStatus.DEPOSIT_DETECTED,
        [FeatherBackendStatus.TRADING]: FeatherOrderStatus.TRADING,
        [FeatherBackendStatus.TRADED]: FeatherOrderStatus.TRADED,
        [FeatherBackendStatus.WITHDRAWING]: FeatherOrderStatus.SENDING_TO_DESTINATION,

        // Success state
        [FeatherBackendStatus.COMPLETED]: FeatherOrderStatus.COMPLETED,

        // Failure states
        [FeatherBackendStatus.DEPOSIT_TIMEOUT]: FeatherOrderStatus.EXPIRED,
        [FeatherBackendStatus.TRADE_FAILED]: FeatherOrderStatus.FAILED,
        [FeatherBackendStatus.WITHDRAWAL_FAILED]: FeatherOrderStatus.WITHDRAWAL_FAILED,
        [FeatherBackendStatus.FAILED]: FeatherOrderStatus.FAILED,
    }

    return statusMap[backendStatus] || FeatherOrderStatus.UNKNOWN
}
